export const GET_ALL_PENDING_STORE_PAYOUTS = 'GET_ALL_PENDING_STORE_PAYOUTS';
export const PAYOUT_REALEASED = 'PAYOUT_REALEASED';
export const GET_ALL_COMPLETED_STORE_PAYOUTS = 'GET_ALL_COMPLETED_STORE_PAYOUTS';
export const GET_ALL_DELIVERY_COLLECTION = 'GET_ALL_DELIVERY_COLLECTION';
export const DELIVERY_COLLECTION_COLLECTED = 'DELIVERY_COLLECTION_COLLECTED';

export const GET_ALL_DELIVERY_COLLECTION_LOGS = 'GET_ALL_DELIVERY_COLLECTION_LOGS';

export const GET_SINGLE_USER_DELIVERY_COLLECTION_LOGS = 'GET_SINGLE_USER_DELIVERY_COLLECTION_LOGS';
